import { router } from '@inertiajs/vue3';

export function usePerfilNavigation() {
    const getPerfilRoute = () => route('perfil');

    const goToPerfil = () => router.visit(getPerfilRoute());

    return { getPerfilRoute, goToPerfil };
}
